/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
interface VersionHistoryProps {
  themeMode: string
}

const VersionHistory: FC<VersionHistoryProps> = ({ themeMode }) => (
  <>
    <div className="card h-100">
      <div className="card-body">
        <div className="d-flex flex-column justify-content-center align-items-center gap-5 mb-6 h-100">
          <img
            src={`/media/logos/vampp-logo-${themeMode === 'light' ? 'dark' : 'white'}.png`}
            alt="logo"
            width={200}
            className="logo"
          />
          <h1> Current Version: v1.0  (January 2025)</h1>
          <p className=" fs-5  text-center">
            Fully built based on dbNSFP 4.9A (PMID: <a href='https://pubmed.ncbi.nlm.nih.gov/21520341/' target='_blank' rel='noreferrer'>21520341</a>, PMID: <a href='https://pubmed.ncbi.nlm.nih.gov/33261662/' target='_blank' rel='noreferrer'>33261662</a>), human reference genome version hg38.
          <br/>
          Canonical transcript annotations were made on Ensemble version 111 (release: 01.2024), and variant groups were defined based on ClinVar submissions (release: 08.2024).

        </p>


      </div>

    </div>
  </div>
  </>
)

const VersionHistoryWrapper: FC = () => {
  const [themeMode, setThemeMode] = useState<string>('light')

  useEffect(() => {
    const currentTheme = document.documentElement.getAttribute('data-bs-theme')
    setThemeMode(currentTheme === 'light' ? 'light' : 'dark')

    const observer = new MutationObserver(() => {
      const updatedTheme = document.documentElement.getAttribute('data-bs-theme')
      setThemeMode(updatedTheme === 'light' ? 'light' : 'dark')
    })

    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-bs-theme'] })

    return () => observer.disconnect()
  }, [])
  const sampleData = [
    { category: "A", value: 10 },
    { category: "A", value: 15 },
    { category: "B", value: 20 },
    { category: "B", value: 25 },
    { category: "C", value: 30 },
    { category: "C", value: 35 },
  ];
  return (
    <>
      <VersionHistory themeMode={themeMode} />
    </>
  )
}

export { VersionHistoryWrapper }
